import { render, staticRenderFns } from "./peiJianDialog.vue?vue&type=template&id=1f8140c3&scoped=true"
import script from "./peiJianDialog.vue?vue&type=script&lang=js"
export * from "./peiJianDialog.vue?vue&type=script&lang=js"
import style0 from "./peiJianDialog.vue?vue&type=style&index=0&id=1f8140c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8140c3",
  null
  
)

export default component.exports